// contexto de permisos de administrador

import { fetchAuthSession } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import React, { createContext, useEffect, useState } from 'react'

// Define the shape of the context value
interface PermissionContextType {
  admin: boolean | undefined
}
// Create the context
export const PermissionContext = createContext<PermissionContextType>({
  admin: undefined
})

// Create a provider component
export const PermissionProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [admin, setAdmin] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const fetchAuth = async (): Promise<void> => {
      try {
        const fetchedUser = await fetchAuthSession()
        const groups =
          fetchedUser.tokens?.accessToken?.payload?.['cognito:groups'] ?? []
        setAdmin((groups as string[]).includes('jjaaAdmins'))
      } catch (error) {
        console.error('🚀 ~ PermissionProvider ~ error', error)
      }
    }

    void fetchAuth()

    // This provider mounts above the Authenticator, before the user signs
    // in, so the first check runs without a session and finds no groups.
    // Re-check on every auth change so the admin UI shows up right after
    // login instead of only after a manual refresh.
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn' || payload.event === 'tokenRefresh') {
        void fetchAuth()
      }
      if (payload.event === 'signedOut') {
        setAdmin(undefined)
      }
    })
    return unsubscribe
  }, [])

  return (
    <PermissionContext.Provider value={{ admin }}>
      {children}
    </PermissionContext.Provider>
  )
}
